export const DAY_COLUMN_SIZE_DESKTOP = 30;
export const DAY_COLUMN_SIZE_MOBILE = 36;
